import { Stack } from '@mui/material';
import { Form } from 'react-final-form';
import { Button, InfoDialog, TextField } from '@occc-app/design-system';
import { CustomDataForm } from './custom-data.types';
import { validateCustomDataForm } from './custom-data.validation';

type CustomDataEditModalProps = {
  isOpen: boolean;
  initialValues: CustomDataForm;
  handleClose: () => void;
  handleSubmit: (values: CustomDataForm) => Promise<void>;
};

export const CustomDataEditModal = ({
  isOpen,
  initialValues,
  handleClose,
  handleSubmit,
}: CustomDataEditModalProps) => (
  <InfoDialog dialogTitle='Edit Custom Data' onClose={handleClose} open={isOpen} fullWidth>
    <Form<CustomDataForm>
      onSubmit={handleSubmit}
      initialValues={initialValues}
      validate={validateCustomDataForm}
      render={(props) => (
        <>
          <TextField name='customData' placeholder='Enter custom data here' multiline rows={12} />
          <Stack direction='row' pt={2} spacing={2} justifyContent='flex-end'>
            <Button variant='outlined' onClick={handleClose}>
              Cancel
            </Button>
            <Button
              variant='contained'
              color='primary'
              disabled={props.submitting || props.invalid || props.pristine}
              onClick={props.handleSubmit}
            >
              Save
            </Button>
          </Stack>
        </>
      )}
    />
  </InfoDialog>
);
